import React from 'react'
import Swal from 'sweetalert2'
import Constant, { getCurrency, getHourSlots } from '../../../Constant'
import axios from 'axios'
import ImageCropper from '../../../common/ImageCropper/ImageCropper'
import moment from 'moment'
import Toggle from 'react-toggle'
import CheckPermission from '../../../common/Permissions/CheckPermission'

class OfferCategoryAdd extends React.Component {
  state = {
    title_en: '',
    title_ar: '',
    img_en: '',
    img_ar: '',
    offer_id: '',
    list: [],
    types: [],
    referenceList: [],
    isListLoading: false,
    isSaving: false,
    typeEnum: {
      CHALET: 'CH',
      CRUISE: 'C',
      EVENT: 'E',
    },
    meta_title_en: '',
    meta_title_ar: '',
    meta_desc_en: '',
    meta_desc_ar: '',
    meta_keywords_en: '',
    meta_keywords_ar: '',
    h1_ar: '',
    h1_en: '',
    h2_ar: '',
    h2_en: '',
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  componentDidMount() {
    if (this.props.id) {
      this.loadData(this.props.id)
    }
    if (this.props?.offerId) {
      this.setState({ offer_id: this.props.offerId })
    }
  }

  onSave = async () => {
    // let is_valid = true
    for (const item of this.state.types) {
      if (item.event_date_selection_type == 'range') {
        if (item.event_end_date == '' || item.event_start_date == '') {
          Swal.fire({
            title: 'Please Select Event Start & End date',
            icon: 'error',
          })
          return
        }
        if (item.event_start_date > item.event_end_date) {
          Swal.fire({
            title: 'Start Date should before End date',
            icon: 'error',
          })
          return
        }
      } else if (item.event_date_selection_type == 'single' && item.event_dates.length == 0) {
        Swal.fire({
          title: 'Please select event dates',
          icon: 'error',
        })
        return
      }
      // if (item.type == 'CRUISE') {
      //   let selectedDestination = item?.destinationList?.find((itm) => item.destination_id == itm.id)

      //   if (selectedDestination.price >= item.price) {
      //     is_valid = false
      //   }
      // }
    }
    // if (!is_valid) {
    //   Swal.fire({
    //     title: 'Please check old price must me more then new offer price',
    //     icon: 'error',
    //   })
    //   return
    // }

    const formData = new FormData()

    formData.append('title_en', this.state.title_en)
    formData.append('title_ar', this.state.title_ar)
    formData.append('offer_id', this.state.offer_id)

    formData.append('meta_title_en', this.state.meta_title_en)
    formData.append('meta_title_ar', this.state.meta_title_ar)
    formData.append('meta_desc_en', this.state.meta_desc_en)
    formData.append('meta_desc_ar', this.state.meta_desc_ar)
    formData.append('meta_keywords_en', this.state.meta_keywords_en)
    formData.append('meta_keywords_ar', this.state.meta_keywords_ar)
    formData.append('h1_ar', this.state.h1_ar)
    formData.append('h1_en', this.state.h1_en)
    formData.append('h2_ar', this.state.h2_ar)
    formData.append('h2_en', this.state.h2_en)

    if (this.state.img_en?.type) {
      formData.append('img_en', this.state.img_en, 'your_original_filename.jpeg')
    }
    if (this.state.img_ar?.type) {
      formData.append('img_ar', this.state.img_ar, 'your_original_filename.jpeg')
    }

    this.setState({ isSaving: true })

    var request
    if (!this.state.id) {
      request = axios.post(Constant.getAPI() + '/offers/create-offer-category', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      formData.append('id', this.state.id)
      request = axios.put(Constant.getAPI() + '/offers/update-offer-category', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }

    request
      .then(async (data) => {
        if (data.status === 200 && data.data) {
          for (const tp of this.state.types) {
            let reqData = {
              category_id: data.data.data.id,
              type: tp.type,
              reference_id: tp.reference_id,
              img: tp.img,
              destination_id: tp.destination_id,
              package_id: tp.package_id,
              start_date: tp.start_date,
              start_time: tp.start_time,
              price: tp.price,
              end_date: tp.end_date,
              end_time: tp.end_time,
              order: tp.order,
              event_dates: tp.event_dates,
              event_date_selection_type: tp.event_date_selection_type,
              event_start_date: tp.event_start_date,
              event_end_date: tp.event_end_date,
              hide_timer: tp.hide_timer,
              ...(tp.id && { id: tp.id }),
            }
            await this.saveLinkData(reqData)
          }
          Swal.fire({
            title: this.state.formAction === 'add' ? 'Successfully created.' : 'Successfully updated.',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          window.history.back()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isSaving: false,
        })
      })
  }

  handleChangeImage = (e, imgKeyName) => {
    this.setState({ [imgKeyName]: e, Edit: false })
  }

  loadData = async (id) => {
    this.setState({ isListLoading: true })
    let list = await axios.get(Constant.getAPI() + '/offers/category-details/' + id, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })

    if (list.status === 200 && list.data) {
      this.setState({
        ...list.data.data,
        isListLoading: false,
      })

      const types = list.data.data?.types

      if (types?.length > 0) {
        await Promise.all(
          types.map(async (tp, index) => {
            const data = {
              link_type: this.state.typeEnum[tp.type],
            }
            await this.getLinkTypeOptions(data, index)
            if (tp.type === 'CRUISE') {
              await this.getDestinationList(tp.reference_id, index)
            }
            if (tp.type === 'CHALET') {
              await this.getPackageList(tp.reference_id, index)
            }
          })
        )
      }
    } else {
      this.setState({
        isListLoading: false,
      })
    }
  }

  add = () => {
    let item = {
      type: '',
      reference_id: '',
      destination_id: '',
      package_id: '',
      start_date: '',
      start_time: '',
      end_date: '',
      end_time: '',
      price: '',
      img: '',
      referenceList: [],
      destinationList: [],
      packageList: [],
      event_dates: [moment().format('YYYY-MM-DD')],
      event_date_selection_type: 'range',
      event_start_date: moment().format('YYYY-MM-DD'),
      event_end_date: moment().add(1, 'day').format('YYYY-MM-DD'),
    }

    this.setState({
      types: [...this.state.types, item],
    })
  }

  handleChangeType = async (index, event) => {
    let list = this.state.types
    const selectedName = event.target.name
    const selectedValue = event.target.value
    if (selectedName == 'hide_timer') {
      list[index][selectedName] = event.target.checked
    } else {
      if (selectedName === 'type') {
        const data = {
          link_type: this.state.typeEnum[selectedValue],
        }
        await this.getLinkTypeOptions(data, index)
      } else if (selectedName === 'reference_id' && list[index].type === 'CRUISE') {
        await this.getDestinationList(selectedValue, index)
      } else if (selectedName === 'reference_id' && list[index].type === 'CHALET') {
        await this.getPackageList(selectedValue, index)
      } else if (selectedName === 'event_date_selection_type') {
        list[index].event_dates = [moment().format('YYYY-MM-DD')]
        list[index].event_start_date = selectedValue == 'range' ? moment().format('YYYY-MM-DD') : null
        list[index].event_end_date = selectedValue == 'range' ? moment().add(1, 'day').format('YYYY-MM-DD') : null
      } else if (selectedName === 'event_start_date' && selectedValue > list[index].event_end_date) {
        list[index].event_end_date = moment(selectedValue, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD')
      }

      list[index][selectedName] = selectedValue
    }

    this.setState({
      types: list,
    })
  }

  getLinkTypeOptions = async (data, index) => {
    await axios
      .post(Constant.getAPI() + '/ads/link-data', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState((prevState) => {
          const updatedTypes = [...prevState.types] // Create a shallow copy
          updatedTypes[index].referenceList = res.data.data
          return { types: updatedTypes }
        })
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.log('Error while getting link types', err)
      })
  }

  getDestinationList = async (cruiseId, index) => {
    await axios
      .get(Constant.getAPI() + '/offers/list-destinations/' + cruiseId, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState((prevState) => {
          const updatedTypes = [...prevState.types] // Create a shallow copy
          updatedTypes[index].destinationList = res.data.data
          return { types: updatedTypes }
        })
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.log('Error while getting link types', err)
      })
  }

  getPackageList = async (chaletID, index) => {
    await axios
      .get(Constant.getAPI() + '/chalet/list-package/' + chaletID, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState((prevState) => {
          const updatedTypes = [...prevState.types] // Create a shallow copy
          updatedTypes[index].packageList = res.data.data
          return { types: updatedTypes }
        })
      })
      .catch((err) => {
        // eslint-disable-next-line
        console.log('Error while getting link types', err)
      })
  }

  handleChangeTypeImage = (index, event, imgKeyName) => {
    let list = this.state.types

    list[index][imgKeyName] = event

    if (imgKeyName === 'img') {
      list[index][imgKeyName] = event
    }

    this.setState({
      types: list,
    })
  }

  saveLinkData = async (data) => {
    const formData = new FormData()
    formData.append('category_id', data.category_id)
    formData.append('type', data.type)
    formData.append('reference_id', data.reference_id)
    formData.append('destination_id', data.destination_id)
    formData.append('package_id', data.package_id)
    if (data.price) {
      formData.append('price', data.price)
    }
    formData.append('start_date', data.start_date)
    formData.append('start_time', data.start_time)
    formData.append('end_date', data.end_date)
    formData.append('end_time', data.end_time)
    formData.append('order', data.order)
    formData.append('hide_timer', data.hide_timer)

    if (data.event_date_selection_type == 'range') {
      let dates = []

      const startDate = moment(data.event_start_date, 'YYYY-MM-DD')
      const endDate = moment(data.event_end_date, 'YYYY-MM-DD')

      let currentDate = startDate
      while (currentDate.isSameOrBefore(endDate)) {
        dates.push(currentDate.format('YYYY-MM-DD'))
        currentDate.add(1, 'days')
      }

      formData.append('event_dates', dates)
    } else {
      formData.append('event_dates', data.event_dates)
    }

    formData.append('event_date_selection_type', data.event_date_selection_type)
    formData.append('event_start_date', data.event_start_date)
    formData.append('event_end_date', data.event_end_date)

    if (data.img?.type) {
      formData.append('img', data.img, 'your_original_filename.jpeg')
    }

    if (!data.id) {
      await axios.post(Constant.getAPI() + '/offers/add-offer-links', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    } else {
      formData.append('id', data.id)
      await axios.put(Constant.getAPI() + '/offers/update-offer-links', formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
    }
  }

  addEventDate = (index) => {
    let tempData = this.state.types
    tempData[index].event_dates = [...(tempData[index].event_dates || []), moment().format('YYYY-MM-DD')]

    this.setState({
      types: tempData,
    })
  }

  removeEventDate = async (index, type_index) => {
    let tempData = this.state.types

    let list = tempData[type_index].event_dates
    list.splice(index, 1)

    tempData[type_index].event_dates = list

    this.setState({
      types: tempData,
    })
  }

  handleEventDate = async (index, type_index, event) => {
    let tempData = this.state.types
    tempData[type_index].event_dates[index] = event.target.value

    this.setState({
      types: tempData,
    })
  }

  remove = async (index) => {
    let list = this.state.types
    if (list[index]?.id) {
      await this.deleteTypeLink(list[index].id)
    }
    list.splice(index, 1)
    this.setState({
      types: list,
    })
  }

  deleteTypeLink = async (id) => {
    await axios.delete(Constant.getAPI() + '/offers/delete-offer-link/' + id, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
        country_short_name: `${localStorage.getItem('countryShortName')}`,
      },
    })
  }

  render() {
    return (
      <div className="">
        <div className="card-body">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Title: English</label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.title_en}
                    name="title_en"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-3 col-form-label">Title: Arabic</label>
                <div className="col-md-9">
                  <input
                    type="text"
                    className="form-control"
                    value={this.state.title_ar}
                    name="title_ar"
                    onChange={this.handleChange}
                  />
                </div>
              </div>
            </div>
            <CheckPermission permission={'manage-meta-tags'}>
              <div
                className="col-md-12"
                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
              ></div>
              <h5 style={{ marginBottom: 23, marginLeft: 13, fontWeight: 'bold', fontSize: 18 }}>Meta Settings</h5>
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_en"
                      id="meta_title_en"
                      placeholder="Meta Title: English"
                      onChange={this.handleChange}
                      value={this.state.meta_title_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Title: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_title_ar"
                      id="meta_title_ar"
                      placeholder="Meta Title: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_title_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta keywords: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_en"
                      id="meta_keywords_en"
                      placeholder="Meta keywords: English"
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta keywords: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_keywords_ar"
                      id="meta_keywords_ar"
                      placeholder="Meta keywords: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_keywords_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_en"
                      id="meta_desc_en"
                      placeholder="Meta Description: English"
                      onChange={this.handleChange}
                      value={this.state.meta_desc_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Meta Description: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="meta_desc_ar"
                      id="meta_desc_ar"
                      placeholder="Meta Description: Arabic"
                      onChange={this.handleChange}
                      value={this.state.meta_desc_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_en"
                      id="h1_en"
                      placeholder="H1: English"
                      onChange={this.handleChange}
                      value={this.state.h1_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H1: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h1_ar"
                      id="h1_ar"
                      placeholder="H1: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h1_ar}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: English</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_en"
                      id="h2_en"
                      placeholder="H2: English"
                      onChange={this.handleChange}
                      value={this.state.h2_en}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">H2: Arabic</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="h2_ar"
                      id="h2_ar"
                      placeholder="H2: Arabic"
                      onChange={this.handleChange}
                      value={this.state.h2_ar}
                    />
                  </div>
                </div>
              </div>
            </CheckPermission>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: English</div>
                <div className="col-sm-6">
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_en || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_en')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-sm-3">Image: Arabic</div>
                <div className="col-sm-6">
                  <ImageCropper
                    ratio={1 / 1}
                    img={this.state.img_ar || null}
                    onChange={(e) => {
                      this.handleChangeImage(e, 'img_ar')
                    }}
                  ></ImageCropper>
                </div>
              </div>
            </div>
            <div
              className="col-md-12"
              style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
            >
              <div style={{ marginTop: 10, fontWeight: 'bold', fontSize: 18 }}>
                Offer Item
                <button
                  type="button"
                  className="btn btn-dark btn-round p-1 m-l-10"
                  onClick={this.add}
                >
                  <i className="f-15 icofont icofont-plus m-0"></i>
                </button>
              </div>
            </div>
            <div className="col-md-12">
              {this.state.types.map((item, index) => (
                <div
                  className="row p-10 border m-b-10 bg-light"
                  key={index}
                >
                  <div className="col-11 p-0">
                    <div className="form-group row m-0">
                      <label className="col-12 col-form-label text-bold">{index + 1}#</label>
                    </div>
                  </div>
                  <div className="col-md-1 text-right p-0">
                    <button
                      type="button"
                      className="btn btn-link text-danger font-weight-bold p-1"
                      onClick={() => {
                        this.remove(index)
                      }}
                    >
                      Remove
                    </button>
                  </div>
                  <div
                    className="col-md-12 p-t-10"
                    style={{ borderTop: '1px solid #EEE' }}
                  >
                    <div className="row">
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Type</label>
                          <div className="col-sm-8">
                            <select
                              name="type"
                              className="form-control"
                              onChange={this.handleChangeType.bind(this, index)}
                              value={item.type}
                            >
                              <option value="">Select Type</option>
                              <option value="CRUISE">Cruise</option>
                              <option value="CHALET">Chalet</option>
                              <option value="EVENT">Event</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Select {item.type}</label>
                          <div className="col-sm-8">
                            <select
                              value={item.reference_id}
                              name="reference_id"
                              onChange={this.handleChangeType.bind(this, index)}
                              className="form-control"
                            >
                              <option value="">Select</option>
                              {this.state.types[index]?.referenceList?.map((item) => (
                                <option
                                  key={item.id}
                                  value={item.id}
                                >
                                  {item.name_en}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        {item.type === 'CRUISE' && (
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Select Destination</label>
                            <div className="col-sm-8">
                              <select
                                value={item.destination_id}
                                name="destination_id"
                                onChange={this.handleChangeType.bind(this, index)}
                                className="form-control"
                              >
                                <option value="">Select</option>
                                {this.state.types[index]?.destinationList?.map((item) => (
                                  <option
                                    key={item.id}
                                    value={item.id}
                                  >
                                    {item.destination_address_en}({item.price} {getCurrency(item.country)})
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}
                        {item.type === 'CHALET' && (
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Select Package</label>
                            <div className="col-sm-8">
                              <select
                                value={item.package_id}
                                name="package_id"
                                onChange={this.handleChangeType.bind(this, index)}
                                className="form-control"
                              >
                                <option value="">Select</option>
                                {this.state.types[index]?.packageList?.map((item) => (
                                  <option
                                    key={item.id}
                                    value={item.id}
                                  >
                                    {item.name_en}({item.price} {getCurrency(item.country)})
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Old Price</label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              id="price"
                              name="price"
                              className="form-control"
                              onChange={this.handleChangeType.bind(this, index)}
                              value={item.price}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Booking Start Date</label>
                          <div className="col-sm-8">
                            <input
                              type="date"
                              min={moment().format('YYYY-MM-DD')}
                              id="start_date"
                              name="start_date"
                              className="form-control"
                              onChange={this.handleChangeType.bind(this, index)}
                              value={item.start_date}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Booking Start Time</label>
                          <div className="col-sm-8">
                            <select
                              name="start_time"
                              className="form-control"
                              value={item.start_time}
                              onChange={this.handleChangeType.bind(this, index)}
                            >
                              <option value="">Select time(HH:MM)</option>
                              {getHourSlots().map(
                                (itm) =>
                                  itm.value != '24:00:00' && (
                                    <option
                                      value={itm.value}
                                      key={itm.value}
                                    >
                                      {itm.label}
                                    </option>
                                  )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Booking End Date</label>
                          <div className="col-sm-8">
                            <input
                              type="date"
                              min={moment().format('YYYY-MM-DD')}
                              id="end_date"
                              name="end_date"
                              className="form-control"
                              onChange={this.handleChangeType.bind(this, index)}
                              value={item.end_date}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Booking End Time</label>
                          <div className="col-sm-8">
                            <select
                              name="end_time"
                              className="form-control"
                              value={item.end_time}
                              onChange={this.handleChangeType.bind(this, index)}
                            >
                              <option value="">Select time(HH:MM)</option>
                              {getHourSlots().map(
                                (itm) =>
                                  itm.value != '24:00:00' && (
                                    <option
                                      value={itm.value}
                                      key={itm.value}
                                    >
                                      {itm.label}
                                    </option>
                                  )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Order</label>
                          <div className="col-sm-8">
                            <input
                              type="number"
                              className="form-control"
                              value={item.order}
                              name="order"
                              onChange={this.handleChangeType.bind(this, index)}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-12 m-b-15"
                        style={{
                          borderTop: '1px solid #eee',
                        }}
                      ></div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Event Date Selection type</label>
                          <div className="col-sm-8">
                            <select
                              name="event_date_selection_type"
                              className="form-control"
                              value={item.event_date_selection_type}
                              onChange={this.handleChangeType.bind(this, index)}
                            >
                              <option value="range">Range</option>
                              <option value="single">Single</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      {item.event_date_selection_type == 'range' && (
                        <>
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-4 col-form-label">Event Start Date</label>
                              <div className="col-sm-8">
                                <input
                                  type="date"
                                  min={moment().format('YYYY-MM-DD')}
                                  id="event_start_date"
                                  name="event_start_date"
                                  className="form-control"
                                  onChange={this.handleChangeType.bind(this, index)}
                                  value={item.event_start_date}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group row">
                              <label className="col-sm-4 col-form-label">Event End Date</label>
                              <div className="col-sm-8">
                                <input
                                  type="date"
                                  min={
                                    item.event_start_date
                                      ? moment(item.event_start_date, 'YYYY-MM-DD').add(1, 'day').format('YYYY-MM-DD')
                                      : moment().format('YYYY-MM-DD')
                                  }
                                  id="event_end_date"
                                  name="event_end_date"
                                  className="form-control"
                                  onChange={this.handleChangeType.bind(this, index)}
                                  value={item.event_end_date}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {item.event_date_selection_type == 'single' && (
                        <>
                          <div
                            className="col-4 p-0"
                            style={{ marginBottom: 20 }}
                          >
                            <div style={{ fontSize: 14 }}>
                              <button
                                type="button"
                                className="btn btn-dark btn-round p-2 m-l-10"
                                onClick={() => {
                                  this.addEventDate(index)
                                }}
                              >
                                <i className="f-15 icofont icofont-plus m-r-10"></i>
                                Add Event Date
                              </button>
                            </div>
                          </div>
                          <div className="col-12">
                            <div className="col-md-12">
                              <div className="row m-b-10">
                                {item?.event_dates?.map((date, i) => (
                                  <div
                                    className="col-2 border p-0"
                                    key={i}
                                  >
                                    <div className="form-group row m-10">
                                      <div className="col-8 p-0">
                                        <input
                                          type="date"
                                          min={moment().format('YYYY-MM-DD')}
                                          id={'date' + i}
                                          name={'date' + i}
                                          className="form-control"
                                          onChange={this.handleEventDate.bind(this, i, index)}
                                          value={date}
                                        />
                                      </div>
                                      <div className="col-4 p-0">
                                        <button
                                          type="button"
                                          className="btn btn-link text-danger font-weight-bold"
                                          onClick={() => {
                                            this.removeEventDate(i, index)
                                          }}
                                          style={{ fontWeight: 'bold', fontSize: 14 }}
                                        >
                                          Remove
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div
                        className="col-12 m-b-15"
                        style={{
                          borderTop: '1px solid #eee',
                        }}
                      ></div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-4 col-form-label">Image</label>
                          <div className="col-sm-8">
                            <ImageCropper
                              ratio={1 / 1}
                              img={item.img || null}
                              onChange={(e) => {
                                this.handleChangeTypeImage(index, e, 'img')
                              }}
                            ></ImageCropper>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="form-group row">
                          <label className="col-sm-3 col-form-label">Hide Timer</label>
                          <div className="col-sm-9">
                            <Toggle
                              className="ml-2 form-control"
                              name="hide_timer"
                              id="hide_timer"
                              onChange={this.handleChangeType.bind(this, index)}
                              checked={item.hide_timer}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="row float-right p-3">
            {this.state.isSaving ? (
              <button
                className="btn btn-grd-disabled mr-2"
                disabled
              >
                Saving...!
              </button>
            ) : (
              <button
                onClick={this.onSave}
                className="btn hor-grd btn-grd-inverse"
              >
                <i className="icofont icofont-save"></i> Save
              </button>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default OfferCategoryAdd
